import { useFragment } from '@apollo/client';
import { gql } from '@/__generated__';
import { AuthInfo } from '@/amplify/get-auth-info';
import { useAppLoader } from './loader';

const MeMinimalFragment = gql(`
fragment MeMinimalFragment on User {
  id
  fullName
  username
}
`);

/**
 *
 * Can be used as a faster alternative to `useMe` to get minimal user data without suspends
 *
 */
export const useAuthInfo = (): AuthInfo => {
  const data = useAppLoader();
  const authInfo = data.authenticated ? data.authInfo : undefined;

  const { data: fragmentData } = useFragment({
    fragment: MeMinimalFragment,
    from: {
      __ref: `User:${authInfo?.id}`,
      __typename: 'User',
    },
  });

  return authInfo
    ? {
        id: authInfo.id,
        email: authInfo.email,
        fullName: fragmentData.fullName || authInfo.fullName,
        username: fragmentData.username || authInfo.username,
        isAdmin: authInfo.isAdmin,
        isEnterprise: authInfo.isEnterprise,
      }
    : {
        id: '',
        email: '',
        fullName: '',
        username: '',
        isAdmin: false,
        isEnterprise: false,
      };
};
